module.exports = __webpack_public_path__ + "img/story008@2x.eb519e74.webp";